'use client';

import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useLinkToolbarButton, useLinkToolbarButtonState } from '@platejs/link/react';

import { Link } from 'lucide-react';

import { FLOATING_ICON_SIZE, ToolbarButton } from 'features/Editor';

export function LinkToolbarButton(props: React.ComponentProps<typeof ToolbarButton>) {
	const { t } = useTranslation();
	const state = useLinkToolbarButtonState();
	const { props: buttonProps } = useLinkToolbarButton(state);

	return (
		<ToolbarButton
			{...props}
			{...buttonProps}
			data-plate-focus
			tooltip={t('Ссылка')}
			icon={<Link size={FLOATING_ICON_SIZE} />}
		/>
	);
}
